<template>
    <div class="container-top mt-5" :class="{ 'container-wide': lgAndUp || xlAndUp }">
        <router-view />
    </div>
</template>
<script setup>
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";

const { lgAndUp, xlAndUp } = deviceBreakpoint();
</script>